import * as React from 'react'
import { IDynamicList } from '../../library/types/IDynamicList'
import {
    TreeList, orderBy, filterBy, mapTree, extendDataItem,
    TreeListTextFilter, TreeListNumericFilter, TreeListDateFilter, TreeListBooleanFilter,
    TreeListToolbar, TreeListRowClickEvent, TreeListColumnProps, TreeListProps
} from '@progress/kendo-react-treelist';
import { CompositeFilterDescriptor, FilterDescriptor, toDataSourceRequestString } from '@progress/kendo-data-query';
import HttpService from '../../service/httpService';

interface ISystemTreeList extends IDynamicList {
    subItemsField: string;
    onRowClick?: (event: TreeListRowClickEvent) => void;
    columns?: TreeListColumnProps[];
    filters?: Array<FilterDescriptor | CompositeFilterDescriptor>;
    data?:[]
}

const expandField = 'expanded';

/* text field which should show in Dropdown  make it as  Id field as 'Id' and text field 'Name' in this*/

export default class SystemTreeList extends React.Component<ISystemTreeList & TreeListProps, any>{
    constructor(props) {
        super(props);
        this.state = {
            data:  this.props.data ? this.props.data : [],
            filter: [],
            sort: [],
            expanded: []
        }
    }


    ensureDataFetched = (isPageChange: boolean=false) => {
        this.setState({
            filter: this.props.filters || [],
        }, () => this.fetchData(this.state.dataState));
    }


    fetchData(dataState: any) {
        if (!this.props.dataSource) {
            this.setState({ data: [] });
            return
        }

        HttpService.get(`${this.props.dataSource}`)
            .then((response: any) => {
                var data = JSON.parse(JSON.stringify(response.data.Data || response.data))
                if (data && data.length > 0) {
                    this.setState({data: data});
                } else {
                    this.setState({ data: [] });
                }
            }).catch((error) => {
            });
    }

    componentDidMount = () => {
        this.ensureDataFetched();
    }

    componentDidUpdate = (prevProps:any) => {
        if (prevProps.dataSource != this.props.dataSource || prevProps.filters != this.props.filters)
            this.ensureDataFetched();
    }
 
    onExpandChange = (e) => {
        this.setState({
            expanded: e.dataItem.expanded ?
                this.state.expanded.filter(id => id !== e.dataItem.Id) :
                [...this.state.expanded, e.dataItem.Id]
        });
    }

    handleDataStateChange = (event) => {
        this.setState({
            dataState: event.dataState
        })
    }

    addExpandField = (dataTree:any) => {
        const expanded = this.state.expanded;
        return mapTree(dataTree, this.props.subItemsField, (item) => 
            extendDataItem(item, this.props.subItemsField, {
                [expandField]: expanded.includes(item.Id)
            })
        );
    }
    handleFilterChange = (event:any) => {
        this.setState({ filter: event.filter});
    };

    onSortChange = (event) => {
        this.setState({
            sort: event.sort,
        });
    };

    processData = () => {
        let { data, sort, filter} = this.state;
        let output = [];

        output = data;
        if(filter) output  = filterBy(output, filter, this.props.subItemsField)
      //  if(sort)  output= orderBy(output, sort, this.props.subItemsField)
        return this.addExpandField(output);
    }

    render() {
        return <TreeList
            {...this.props}
            // {...this.state.dataState}
            style={{ maxHeight: '510px', overflow: 'auto' }}
            expandField={expandField}
            subItemsField={this.props.subItemsField}
            onExpandChange={this.onExpandChange}
            data={this.processData()}
            //filter={this.state.filter}
            //onFilterChange={this.handleFilterChange}

            onSortChange={this.onSortChange}
            //onDataStateChange={this.handleDataStateChange}
            columns={this.props.columns}
            columnMenuFilter={this.state.filter}
            onColumnMenuFilterChange={this.handleFilterChange}
            sort={this.state.sort}
            onRowClick={this.props.onRowClick}
        />
    }
}
